var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ag-grid-vue',{staticClass:"ag-theme-balham",staticStyle:{"height":"550px"},attrs:{"columnDefs":_vm.localcolumnDefs,"rowData":_vm.localrowData,"overlayLoadingTemplate":_vm.overlayLoadingTemplate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }